"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.useCouponDialog = useCouponDialog;
var _react = _interopRequireWildcard(require("react"));
var _CouponAppliedDialog = _interopRequireDefault(require("../components/CouponAppliedDialog/CouponAppliedDialog"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Find the applied coupon in availableCoupons / paymentLine / a coupon object.
const getAppliedCoupon = source => {
  if (!source) return null;
  if (!Array.isArray(source)) {
    return source.couponCode ? source : null;
  }
  // prefer isApplied when the list carries it
  const hasAppliedFlag = source.some(c => c && typeof c.isApplied !== 'undefined');
  if (hasAppliedFlag) {
    return source.find(c => c && c.isApplied && c.couponCode) || null;
  }
  return source.find(c => c && c.couponCode) || null;
};

// Coupon "applied" popup. Returns a `dialog` that opens once per coupon and
// dismisses itself — the design has no close icon.
function useCouponDialog(couponSource) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    autoOpen = true,
    autoCloseMs = 3000,
    dialogProps = {}
  } = options;
  const coupon = (0, _react.useMemo)(() => getAppliedCoupon(couponSource), [couponSource]);
  const [open, setOpen] = (0, _react.useState)(false);
  const shownForRef = (0, _react.useRef)(null);
  const canShow = !!coupon;
  (0, _react.useEffect)(() => {
    if (!autoOpen) return;
    if (!canShow) {
      shownForRef.current = null;
      return;
    }
    if (shownForRef.current !== coupon.couponCode) {
      shownForRef.current = coupon.couponCode;
      setOpen(true);
    }
  }, [autoOpen, canShow, coupon]);
  const close = (0, _react.useCallback)(() => setOpen(false), []);
  const openDialog = (0, _react.useCallback)(() => setOpen(true), []);
  (0, _react.useEffect)(() => {
    if (!open || !autoCloseMs) return undefined;
    const timer = setTimeout(() => setOpen(false), autoCloseMs);
    return () => clearTimeout(timer);
  }, [open, autoCloseMs]);
  const dialog = canShow ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_CouponAppliedDialog.default, {
    open: open,
    onClose: close,
    couponCode: coupon.couponCode,
    discountValue: coupon.discountValue,
    ...dialogProps
  }) : null;
  return {
    dialog,
    open,
    close,
    openDialog,
    coupon
  };
}
var _default = exports.default = useCouponDialog;